<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                :disabled="disableBranch"
                dense
                outlined
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                :disabled="disableDeparment"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                :disabled="disableYear"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                :disabled="disableMonth"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                v-if="disableSearch"
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <!-- data table -->
          <v-col cols="12" v-for="(items, index) in dataItem" :key="index">
            <v-expansion-panels multiple>
              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <template v-slot:actions>
                    <v-icon color="#871B12">
                      mdi-account-circle-outline
                    </v-icon>
                  </template>
                  {{ items.empFull_NameTH }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="6">
                      <v-card elevation="2">
                        <center>
                          <v-avatar
                            class="profile"
                            style="margin-top: 10px"
                            color="grey"
                            size="164"
                            rounded
                          >
                            <v-img :src="items.empImageUrl"></v-img>
                          </v-avatar>
                        </center>
                        <v-col>
                          <v-card-text
                            ><v-icon color="#871B12">mdi-account</v-icon
                            ><strong>ชื่อ-นามสกุล (ภาษาไทย): </strong
                            >{{ items.empFull_NameTH }}
                          </v-card-text>
                          <v-card-text
                            ><v-icon color="#871B12">mdi-account</v-icon
                            ><strong>ชื่อ-นามสกุล (ภาษาอังกฤษ): </strong
                            >{{ items.empFull_NameEN }}
                          </v-card-text>
                          <v-card-text
                            ><v-icon color="#871B12">mdi-account</v-icon
                            ><strong>ชื่อเล่น: </strong>
                            {{ items.empNickname }}
                            <v-icon color="#871B12">mdi-account</v-icon
                            ><strong>เพศ : </strong>
                            {{ items.empGender }}</v-card-text
                          >
                          <v-card-text
                            ><v-icon color="#871B12"> mdi-cake-variant </v-icon
                            ><strong>วัน-เดือน-ปีเกิด : </strong
                            >{{ items.AGE }}</v-card-text
                          >
                          <v-card-text
                            ><v-icon color="#871B12">mdi-account-box</v-icon
                            ><strong>เลขบัตรประจำตัวประชาชน : </strong
                            >{{ items.empIDCard }}</v-card-text
                          >
                          <v-card-text
                            ><v-icon color="#871B12">
                              mdi-cellphone-basic </v-icon
                            ><strong>เบอร์โทรศัพท์ : </strong
                            >{{ items.empTel }}</v-card-text
                          >
                          <v-card-text
                            ><v-icon color="#871B12"> mdi-email </v-icon
                            ><strong>อีเมล์ : </strong>{{ items.empEmail }}
                          </v-card-text>
                        </v-col>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card elevation="2">
                        <v-simple-table fixed-header height="600px">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">วัน/เดือน/ปี</th>
                                <th class="text-left">เวลาเข้างาน</th>
                                <th class="text-left">เวลาเลิกงาน</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(items1, index1) in items.shifttem"
                                :key="index1"
                              >
                                <td>
                                  {{ items1.shiftDay }}/{{
                                    items1.shiftMonth
                                  }}/{{ items1.shiftYear }}
                                </td>
                                <td>
                                  <v-chip
                                    class="ma-2"
                                    :color="items1.colorin"
                                    text-color="white"
                                    @click="openWindows(items1)"
                                  >
                                    {{ items1.checkInStartStamp }}
                                  </v-chip>
                                </td>
                                <td>
                                  <v-chip
                                    class="ma-2"
                                    :color="items1.colorout"
                                    text-color="white"
                                     @click="openWindows2(items1)"
                                  >
                                    {{ items1.checkInEndStamp }}
                                  </v-chip>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-col>
                        <!-- {{items.shifttem}}
                        <label v-for="items2 in items.shifttem" :key="items2" >
                            {{items2.position}}
                            </label> -->
                        <!-- {{items.shifttem}} -->
                        <GmapMap
                          :center="center"
                          map-type-id="terrain"
                          ref="mapRef"
                          :zoom="zoom"
                          style="width: 100%; height: 600px"
                          :options="{ disableDefaultUI: true }"
                        >
                        <GmapMarker :position="center" />
                              <GmapMarker
                                v-for="(m, indexMap1) in dataByEmp.shifttemMapCheckIn"
                                :key="indexMap1"
                                :position="m.positionIn"
                                :clickable="true"
                                :icon="m.iconIn"
                                @click="openWindows(m)"
                              />
                              <GmapMarker
                                v-for="(
                                  m2, indexMap2
                                ) in dataByEmp.shifttemMapCheckout"
                                :key="indexMap2 + 'M2'"
                                :position="m2.positionOut"
                                :clickable="true"
                                :icon="m2.iconOut"
                                @click="openWindows2(m2)"
                              />
                              <gmap-info-window
                                  @closeclick="window_open=false"
                                  :opened="window_open"
                                  :position="infowindow_position"
                                  :options="{
                                    pixelOffset: {
                                      width: 0,
                                      height: -35
                                    }
                                  }"
                              >
                                  {{infowindow_detail}}
                              </gmap-info-window>
                        </GmapMap>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import { gmapApi } from 'vue2-google-maps'
export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    moment,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงานเช็คอิน - เช็คเอ้าท์',
          disabled: false,
          href: '/CheckINOUT/ReportCheckINOUT'
        }
      ],
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columns: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'Map', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataExportItem: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true,
      disableSearch: true,
      year: '', // บริษัท
      month: '', // บริษัท
      disableYear: true,
      disableMonth: true,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      panel: [0, 1],
      zoom: 14,
      window_open: false,
      infowindow_position: {lat: 10, lng: 10.0},
      infowindow_detail: ''
    }
  },
  async mounted () {
    await this.geolocate()
    await this.getGetToken()
    this.dataReady = false

    this.month = this.getMonthTh()
    // let date = new Date()
    this.year = moment().format('YYYY')
    // this.getData()
    await this.getDataCompany()
  },
  methods: {
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          console.log('center : ', center)
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
          alert('กรุณาเปิด location ของท่าน')
        }
      )
    },
    async getData () {
      console.log('Company :', this.Company)
      console.log('Branch :', this.Branch)
      console.log('Department :', this.Department)
      this.dataReady = false
      this.dataItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee/get?masCompanyCode=' +
            this.Company +
            '&masBranchCode=' +
            this.Branch +
            '&masDepartmentCode=' +
            this.Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          this.dataExportItem = response.data
          this.shift_import()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async shift_import () {
      this.dataItem.forEach(async (dt) => {
        dt.empImageUrl = this.DNS_IP + '/' + dt.empImageUrl
        console.log(dt)
        this.dataReady = false
        // this.shifttem = []
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/shift_import/get?empCode=' +
              dt.empCode +
              '&shiftMonth=' +
              this.getMonthThToINT(this.month) +
              '&shiftYear=' +
              this.year
          )
          .then(async (response) => {
            this.dataReady = true
            dt.shifttem = response.data
            dt.shifttemMapCheckIn = response.data
            dt.shifttemMapCheckout = response.data
            this.mapGetDataCheckIn(dt.shifttemMapCheckIn)
            this.mapGetDataCheckOut(dt.shifttemMapCheckout)
            dt.shifttem.forEach((shifttem) => {
              if (shifttem.checkInStartStamp) {
                var date =
                  shifttem.checkInYear +
                  '-' +
                  shifttem.checkInMonth +
                  '-' +
                  shifttem.checkInDay
                var startStamp = new Date(
                  date + ' ' + shifttem.checkInStartStamp
                )

                var masShiftTypeStartTime = new Date(
                  date + ' ' + shifttem.masShiftTypeStartTime
                )
                if (startStamp > masShiftTypeStartTime) {
                  shifttem.colorin = 'red'
                } else {
                  shifttem.colorin = 'green'
                }

                if (shifttem.checkInEndStamp) {
                  shifttem.checkInEndStamp = shifttem.checkInEndStamp
                  shifttem.colorout = 'green'
                } else {
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.colorout = '-'
                }
              } else {
                shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorin = '-'
                shifttem.colorout = '-'
              }
            })
            dt.shifttem = dt.shifttem
              .slice()
              .sort((a, b) => a.shiftDay - b.shiftDay)
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = true
          })
      })
    },
    mapGetDataCheckIn (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInStartLat && shifttem.checkInStartLong) {
          var position = {
            lat: parseFloat(shifttem.checkInStartLat),
            lng: parseFloat(shifttem.checkInStartLong)
          }

          shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          shifttem.positionIn = position
          this.center = position
        }
      })
    },
    mapGetDataCheckOut (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInEndLat && shifttem.checkInEndLong) {
          var position = {
            lat: parseFloat(shifttem.checkInEndLat),
            lng: parseFloat(shifttem.checkInEndLong)
          }

          shifttem.iconOut =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fout.png?alt=media'
          shifttem.positionOut = position
          this.center = position
        }
      })
    },
    openWindows (m) {
      console.log('m', m)
      this.zoom = 19
      this.center = m.positionIn
      this.window_open = true
      this.infowindow_position = m.positionIn

      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nเข้างานเมื่อ ' + m.checkInStartStamp
      // this.panToMarker(this.center)
    },
    openWindows2 (m) {
      console.log('m2', m)
      this.zoom = 19
      this.center = m.positionOut
      this.infowindow_position = m.positionOut
      this.window_open = true
      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nออกงานเมื่อ ' + m.checkInEndStamp
      // this.panToMarker(this.center)
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyCode
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          // // console.log(error)
        })
    },
    // สาขา
    async getDataBranch (company) {
      console.log(company)
      this.BranchItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/" + "get?masCompanyCode=" + company,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.disableBranch = false
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchCode
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.disableBranch = true
        })
    },
    // แผนก
    async getDataDepartment (branch) {
      console.log(branch)
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/get?masBranchCode=" + branch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.disableDeparment = false
          this.disableYear = false
          this.disableMonth = false
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentCode
            d = s
            this.DepartmentItem.push(d)
          }
          // // console.log('getDataDepartment : ', this.DepartmentItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.disableDeparment = true
          this.disableYear = true
          this.disableMonth = true
          // // console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style scope>
.Color-Font {
  color: #808588;
}
.Color-Font-Action {
  color: #b61c1c;
}
.Color-Font-Preview {
  color: #262a34;
}
.Color-Button {
  color: #b61c1c;
}
.Divider {
  border: 2px solid #808588;
  background: #808588;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/CheckINOUT/ReportCheckINOUT.vue